import React  from 'react';
import './App.css';
import './Court.css';
import CourtLang from './CourtLang.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TbCopy, TbCopyCheckFilled  } from "react-icons/tb";
import { TbCloudDownload } from "react-icons/tb";
import { MdOutlineQrCode, MdLiveTv, MdRadioButtonChecked } from "react-icons/md"
import { BsGear } from "react-icons/bs";

import { useNavigate } from "react-router-dom";

class CourtMain extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			courtID: 0,
			courtName: "",
			eventArray: null,
			year: 0,
			month: 0,
			day: 0,
			buttonPressedYN: false,
			settingsPressedYN: false,
			qrCodeLinkPressedYN: false,
			copyMouseDownIndex: -1,
		}
	}

	componentDidMount() {

		var courtID = this.props.courtID;
		this.serverGetCourtData(courtID);

		const now = new Date();
		var year = now.getFullYear();
		var month = now.getMonth() + 1;
		var day = now.getDate();

		this.serverGetEventListByCourtID(courtID, year, month, day);
		
		this.setState({
			year: year,
			month: month,
			day: day,
		});
	}

	componentDidUpdate() {
		
		var courtID1 = this.state.courtID;
		var courtID2 = this.props.courtID;
		
		if (courtID1 !== courtID2) {
			this.refreshData(courtID2);
			this.setState({
				courtID: courtID2,
			});
		}
		
		var refreshCourtMainYN = this.props.refreshCourtMainYN;
		if (refreshCourtMainYN) {
			this.refreshData(courtID2);
			this.props.setRefreshCourtMainYN(false);
		}
	}
	
	refreshData(courtID) {
		this.serverGetEventListByCourtID(courtID, this.state.year, this.state.month, this.state.day);
	}

	async serverGetCourtData(courtID) {
		
		if (courtID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcourtdata?courtid=" + courtID;
		
		var jsonObj = null;
		var courtName = "";
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
			courtName = jsonObj.courtName;
		} catch (err) {
		}
		
		this.setState({
			courtName: courtName,
		});
	}
	
	async serverGetEventListByCourtID(courtID, year, month, day) {
		
		if (courtID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/geteventlistbycourtid?courtid=" + courtID;
		url = url + "&year=" + year;
		url = url + "&month=" + month;
		url = url + "&day=" + day;
		
		var eventArray = null;
		
		try {
			var res = await fetch(url);
			eventArray = await res.json();
		} catch (err) {
		}
		
		this.setState({
			eventArray: eventArray,
		});
	}
	
	async serverGetCourtWithEventsecretListByLocationID(locationID) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcourtwitheventsecretlistbylocationid?locationid=" + locationID;
		
		var jsonObj = null;

		try {
			var res = await fetch(url);
			jsonObj = await res.json();
		} catch (err) {
		}
		
		return jsonObj;
	}

	async serverButtonPressed(courtID) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/buttonpressed?courtid=" + courtID;

		try {
			var res = await fetch(url);
			await res.text();
		} catch (err) {
		}
	}
	
	async serverTvSendVideo(locationID, filenameExt) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/tvplayvideo?locationid=" + locationID;
		url = url + "&filenameext=" + filenameExt;
		console.log(url);

		try {
			var res = await fetch(url);
			await res.text();
		} catch (err) {
		}
	}
	
	handleViewVideo(filename) {
		var filenameExt = filename + ".mp4";
		var baseURLAPI = this.props.baseURLAPI;
		var fileUrl = baseURLAPI + "/clips/" + filenameExt;
		window.open(fileUrl, "_blank");
	}
	
	handleDownload(filename) {

		var filenameExt = filename + ".mp4";
		var baseURLAPI = this.props.baseURLAPI;
		var fileUrl = baseURLAPI + "/clips/" + filenameExt;

		fetch(fileUrl)
			.then(resp => resp.blob())
			.then(blob => {
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = filenameExt; // specify file name
			a.click();
			URL.revokeObjectURL(url); // clean up
		}); 
	}
	
	async handleTvPlayVideo(filename) {
		var locationID = this.props.locationID;
		var filenameExt = filename + ".mp4";
		await this.serverTvSendVideo(locationID, filenameExt);
		this.props.showToast(this.props.getLang(CourtLang, "videoSentToTV"));
	}
	
	async copyToClipboard(text) {

		if (navigator.clipboard && navigator.clipboard.writeText) {
			try {
				await navigator.clipboard.writeText(text);
				return true;
			} catch (err) {
			}
		}

		// Fallback for Android/older browsers
		const textarea = document.createElement("textarea");
		textarea.value = text;
		textarea.style.position = "fixed"; // avoid scrolling
		textarea.style.opacity = "0";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();

		try {
			const success = document.execCommand("copy");
			return success;
		} catch (err) {
			return false;
		} finally {
			document.body.removeChild(textarea);
		}
	}	
	
	handleCopyURLMouseDown(index) {
		this.setState({copyMouseDownIndex: index});
	}
	
	async handleCopyURLMouseUp(filename) {
		this.setState({copyMouseDownIndex: -1});
		var filenameExt = filename + ".mp4";
		var baseURLAPI = this.props.baseURLAPI;
		var fileUrl = baseURLAPI + "/clips/" + filenameExt;
		await this.copyToClipboard(fileUrl);
	}
	
	handleCopyURLTouchStart(index) {
		this.handleCopyURLMouseDown(index);
	}
	
	handleCopyURLTouchEnd(filename) {
		this.handleCopyURLMouseUp(filename);
	}
	
	handleButtonPressedMouseDown() {
		this.setState({buttonPressedYN: true});
	}
	
	handleButtonPressedMouseUp() {
		this.props.showToast(this.props.getLang(CourtLang, "buttonPressRequested"));		
		this.setState({buttonPressedYN: false});
		var courtID = this.props.courtID;
		this.serverButtonPressed(courtID);
	}
	
	handleButtonPressedTouchStart() {
		this.handleButtonPressedMouseDown();
	}

	handleButtonPressedTouchEnd() {
		this.handleButtonPressedMouseUp();
	}
	
	handleQRCodeLinkMouseDown() {
		this.setState({qrCodeLinkPressedYN: true});
	}
	
	async handleSettingsMouseUp() {
		this.setState({settingsPressedYN: false});
		var courtID = this.props.courtID;
		const navigate = this.props.navigate;
  		navigate("/courtsettings");
	}
	
	handleSettingsTouchStart() {
		this.handleSettingsMouseDown();
	}

	handleSettingsTouchEnd() {
		this.handleSettingsMouseUp();
	}
	
	handleSettingsMouseDown() {
		this.setState({SettingsPressedYN: true});
	}
	
	async handleQRCodeLinkMouseUp() {
		this.setState({qrCodeLinkPressedYN: false});
		var courtID = this.props.courtID;
		var url = await this.getQrCodeLink(courtID);
		if (url === "") {
			return;
		}
		await this.copyToClipboard(url);
		window.open(url, "_blank");
	}
	
	handleQRCodeLinkTouchStart() {
		this.handleQRCodeLinkMouseDown();
	}

	handleQRCodeLinkTouchEnd() {
		this.handleQRCodeLinkMouseUp();
	}
	
	async getQrCodeLink(courtID1) {

		var locationID = this.props.locationID;
		var courtArray = await this.serverGetCourtWithEventsecretListByLocationID(locationID);
		if (courtArray === null) {
			return "";
		}

		var baseURLAPI = this.props.baseURLAPI;
		var i;
		var itemObj;
		var courtID2;
		var secret;
		var url;
		
		for(i=0; i<courtArray.length; i++) {
			itemObj = courtArray[i];
			courtID2 = itemObj.courtID;
			if (courtID1 === courtID2) {
				secret = itemObj.secret;
				url = baseURLAPI + "/highlights?secret=" + secret;
				return url;
			}			
		}
		
		return "";
	}
	
	prevDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec - 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.serverGetEventListByCourtID(this.state.courtID, year2, month2, day2);	
	}
	
	nextDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec + 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.serverGetEventListByCourtID(this.state.courtID, year2, month2, day2);	
	}

	datePickerSetDate(dateObj) {

		var year = dateObj.getFullYear();
		var month = dateObj.getMonth() + 1;
		var day = dateObj.getDate();

		this.setState({
			year: year,
			month: month,
			day: day,
		});

		this.serverGetEventListByCourtID(this.state.courtID, year, month, day);	
	}
	
	getDateStringFromYMD(year, month, day) {
		var dateString;
		dateString = this.props.getTwoDigits(day) + "." + this.props.getTwoDigits(month) + "." + year + ".";
		return dateString;
	}
	
	getDateObjFromYMD(year, month, day) {

		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);

		return dateObj;
	}
	
	renderDateInput() {
		
		var dateObj = this.getDateObjFromYMD(this.state.year, this.state.month, this.state.day);
		var buttonPressedYN = this.state.buttonPressedYN;
		var qrCodeLinkPressedYN = this.state.qrCodeLinkPressedYN;
		var settingsPressedYN = this.state.settingsPressedYN;

		return (
			<center>
				<div className="CourtMainDateContainer">
					<div className="CourtMainDatePrev" onClick={() => this.prevDate()}>&lt;&lt;</div>
					<DatePicker 
						className="CourtMainDateString" 
						selected={dateObj} onChange={(date) => this.datePickerSetDate(date)} 
						dateFormat="dd.MM.yyyy."
					/>
					<div className="CourtMainDateNext" onClick={() => this.nextDate()}>&gt;&gt;</div>
					<div className="CourtMainDateSettings" 
						onTouchStart={() => this.handleSettingsTouchStart()} 
						onTouchEnd={() => this.handleSettingsTouchEnd()} 
						onMouseDown={() => this.handleSettingsMouseDown()} 
						onMouseUp={() => this.handleSettingsMouseUp()} 
					>
						{!settingsPressedYN && (<BsGear style={{ padding: "5px", color: "black", width: "25px", height: "25px" }} />)}
						{settingsPressedYN && (<BsGear style={{ padding: "5px", color: "blue", width: "30px", height: "30px" }} />)}
					
					</div>					
					<div className="CourtMainDateQRCodeLink" 
						onTouchStart={() => this.handleQRCodeLinkTouchStart()} 
						onTouchEnd={() => this.handleQRCodeLinkTouchEnd()} 
						onMouseDown={() => this.handleQRCodeLinkMouseDown()} 
						onMouseUp={() => this.handleQRCodeLinkMouseUp()} 
					>
						{!qrCodeLinkPressedYN && (<MdOutlineQrCode style={{ padding: "5px", color: "black", width: "25px", height: "25px" }} />)}
						{qrCodeLinkPressedYN && (<MdOutlineQrCode style={{ padding: "5px", color: "blue", width: "30px", height: "30px" }} />)}
					</div>					
					<div className="CourtMainDatePressButton" 
						onTouchStart={() => this.handleButtonPressedTouchStart()} 
						onTouchEnd={() => this.handleButtonPressedTouchEnd()} 
						onMouseDown={() => this.handleButtonPressedMouseDown()} 
						onMouseUp={() => this.handleButtonPressedMouseUp()} 
					>
						{!buttonPressedYN && (<MdRadioButtonChecked style={{ padding: "5px", color: "black", width: "25px", height: "25px" }} />)}
						{buttonPressedYN && (<MdRadioButtonChecked style={{ padding: "5px", color: "blue", width: "30px", height: "30px" }} />)}
					</div>					
				</div>
			</center>
		);
	}

	renderOneEvent(index, itemObj) {

		var key = "event-" + index;
		var filename = itemObj.filename;
		var unixTimeSec = itemObj.unixTimeSec;
		var baseURLAPI = this.props.baseURLAPI;
		var imageURL = baseURLAPI + "/clips/" + filename + ".jpg";
		
		var timeString = this.props.getTimeStringFromUnixTimeSec(unixTimeSec);

		var selectedYN = false;		
		if (index === this.state.copyMouseDownIndex) {
			selectedYN = true;		
		}
		
		// onTouchStart
		// 

		return (
			<div key={key} className="CourtMainOneEvent">
				<div className="CourtMainEventLine1">
					<img className="CourtMainEventImage" onClick={() => this.handleViewVideo(filename)} width={300} src={imageURL} />
				</div>
				<div className="CourtMainEventLine2">
					<div className="CourtMainEvent1" onClick={() => this.handleViewVideo(filename)}>
						{timeString}
					</div>
					<div className="CourtMainEvent2" 
						onTouchStart={() => this.handleCopyURLTouchStart(index)} 
						onTouchEnd={() => this.handleCopyURLTouchEnd(filename)} 
						onMouseDown={() => this.handleCopyURLMouseDown(index)} 
						onMouseUp={() => this.handleCopyURLMouseUp(filename)} 
					>
						{!selectedYN && (<TbCopy style={{ color: "black", width: "25px", height: "25px" }} />)}
						{selectedYN && (<TbCopyCheckFilled style={{ color: "blue", width: "25px", height: "25px" }} />)}
					</div>
					<div className="CourtMainEvent3" onClick={() => this.handleDownload(filename)}>
						<TbCloudDownload style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="CourtMainEvent4" onClick={() => this.handleTvPlayVideo(filename)}>
						<MdLiveTv style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					
				</div>
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
	
	renderAllEvents() {

		var eventArray = this.state.eventArray;		
		if (eventArray === null) {
			return null;
		}

		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<eventArray.length; i++) {
			itemObj = eventArray[i];
			jsxCode = this.renderOneEvent(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div className="CourtMainEventContainer">
				{jsxArray}
			</div>
		);
	}
	
	render() {
		
		var courtName = this.state.courtName;
		var locationName = this.props.locationName;
		
		return (
			<div className="CourtMainTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="CourtMainTitle">{locationName} / {courtName}</div>
				<div style={{height: "10px"}}></div>
				{this.renderDateInput()}
				<div style={{height: "10px"}}></div>
				{this.renderAllEvents()}
			</div>
		);
	}
}

export default function CourtMainFunction(props) {
	const navigate = useNavigate();
	return <CourtMain {...props} navigate={navigate} />;
}


